import RegularButton from '@/components/buttons/RegularButton'
import Divider from '@/components/divider/Divider'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import Grid from '@mui/material/Grid2'
import TextField from '@mui/material/TextField'
import React from 'react'

const GuestBook: React.FC = () => {
  const [name, setName] = React.useState<string>('')
  const [description, setDescription] = React.useState<string>('')
  const [isSending, setIsSending] = React.useState<boolean>(false)
  const maxDescriptionLength = 500

  const sendComment = async () => {
    setIsSending(true)
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name,
        description,
      }),
    }
    try {
      const response = await fetch(
        `${window.env.API_ENDPOINT}/email/comment`,
        requestOptions,
      )
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
    } catch (error) {
      console.error('Error:', error)
    }
    setIsSending(false)
  }

  return (
    <Grid
      container
      direction="column"
      spacing={2}
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Grid size={10}>
        <h1>Gästbok</h1>
      </Grid>

      <Grid container spacing={2} size={{ xs: 11, md: 4 }}>
        <Grid size={12}>
          <TextField
            label="Namn (Valfritt)"
            type="text"
            value={name}
            sx={{ width: '100%' }}
            onChange={(event) => setName(event.target.value)}
          />
        </Grid>
        <Grid size={12}>
          <TextField
            required
            label="Beskrivning"
            type="text"
            multiline
            helperText={`${description.length} / ${maxDescriptionLength}`}
            rows={6}
            value={description}
            sx={{ width: '100%' }}
            onChange={(event) =>
              event.target.value.length <= maxDescriptionLength &&
              setDescription(event.target.value)
            }
          />
        </Grid>

        <Grid size={12} textAlign="end">
          <RegularButton
            label={
              <>
                Skicka <ArrowForwardIcon />
              </>
            }
            isLoading={isSending}
            width={100}
            height={40}
            onClick={sendComment}
          />
        </Grid>
      </Grid>

      <Divider size={{ xs: 11, md: 10 }} />

      <Grid size={10}>
        <h2>Senaste kommentarena</h2>
        <Grid size={12} container direction="row" spacing={2}>
          <Grid size={{ xs: 12, md: 3 }} textAlign="start">
            <i>03.05 | 03:39</i>
            <p>
              Hej Carolina! Vad kul att du vill att vi skall studentspela! Jag
              skall ta vidare din fråga till musikkårens styrelse och så
              återkommer jag till dig så snart jag fått ett svar. Ha en bra dag!
            </p>
          </Grid>

          <Grid size={{ xs: 12, md: 3 }} textAlign="start">
            <i>02.05 | 07:31</i>
            <p>
              Hej!! Tänkte kolla om ni har möjlighet att spela på en
              studentmarsch i Olofström? 3 juni kl 15.00
            </p>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default GuestBook
